import React from "react";
import "./discuss-item.scss";
import {
  CommentOutlined,
  StarOutlined,
  LikeOutlined,
  UserOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { Avatar, Empty, notification, Image } from "antd";
import { NavLink } from "react-router-dom";
import moment from "moment";
import Comments from "../../pages/zhuanlans/zhuanlan_detail_content/comments/comments";
import { isEqual } from "lodash";
import { serial } from "react-lz-editor/global/supports/datas/url";
import { show } from "@ebay/nice-modal-react";
import httpclient from "../../service/httpclient";
import RichText from "../RichText/RichText";
import ResizedImage from "../ResizedImage/resized-image";

function ResizedImg(discussHtml, cnt, mode, width, height) {
  const regex =
    mode === "preview"
      ? /<img[^>]*src=["']([^"']+)["'][^>]*>/g
      : /<img[^>]+data-custom="discuss-img"[^>]*src=["']([^"']+)["'][^>]*>/g;
  let matches = [],
    result = [];
  let match;
  while ((match = regex.exec(discussHtml)) !== null) {
    matches.push(match[1]);
  }
  for (let i = 0; i < cnt; i++) {
    if (matches[i]) {
      result.push(
        <Image
          onClick={(e) => {
            e.preventDefault();
          }}
          className="preview-img-item"
          src={matches[i]}
          width={width}
          height={height}
        />
      );
    }
  }
  return (
    result.length > 0 && <div className="preview-image-wrapper">{result}</div>
  );
}

function areEqual(prevProps, nextProps) {
  return (
    isEqual(prevProps.discussItem, nextProps.discussItem) &&
    isEqual(prevProps.options, nextProps.options) &&
    prevProps.index === nextProps.index &&
    prevProps.userInfo === nextProps.userInfo &&
    prevProps.updateDiscussData === nextProps.updateDiscussData
  );
}

function DiscussItem({
  discussItem,
  options,
  updateDiscussData,
  userInfo,
  updateUserInfo,
}) {
  const { showAvatar, showDetail } = options || true;
  const { showDelete, hideBottom, hideSelectTag } = options || false;
  const searchInput = options?.searchInput;
  if (
    discussItem?.title.includes(searchInput) ||
    discussItem?.html.includes(searchInput) ||
    !searchInput
  ) {
    return (
      <div className="discuss-item">
        <div style={{ display: "flex" }}>
          <div className="discuss-avatar">
            {showAvatar !== false && (
              <div className="discuss-user-avatar">
                <Avatar
                  src={
                    discussItem.select === 3
                      ? "https://cdn.datongbei.com/icdesign-17490288279413045ef81h5a3a.png?imageView2/0/format/jpg/q/90|imageslim"
                      : discussItem.avatar
                  }
                  size={{ xs: 32, sm: 36, md: 40, lg: 40, xl: 40, xxl: 40 }}
                  icon={<UserOutlined />}
                />
              </div>
            )}
          </div>
          <div className="discuss-right-content">
            <div className="discuss-top-bar">
              <div className="discuss-top-tag">
                {discussItem.select === 2 &&
                  showDetail !== false &&
                  !hideSelectTag && (
                    <div className="discuss-select-tag">置顶</div>
                  )}
                {discussItem.select === 1 && !hideSelectTag && (
                  <div className="discuss-select-tag">今日最佳</div>
                )}
              </div>
              <div className="discuss-user-name">{discussItem.username}</div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div className="discuss-title">{discussItem.title}</div>
                <div className="discuss-tag">{discussItem.tag}</div>
              </div>
              <div>
                <NavLink to={"/discuss/detail/" + discussItem.id}>
                  <div
                    className={
                      showDetail !== false
                        ? "discuss-content-preview"
                        : "discuss-content"
                    }
                  >
                    <RichText
                      richText={{
                        type: "HTML",
                        content:
                          showDetail !== false
                            ? discussItem.html
                                .replace(/<figure[^>]*>/g, "")
                                .replace(/<img[^>]*>/g, "")
                            : discussItem.html.replace(
                                /<img[^>]+data-custom="discuss-img"[^>]*>/g,
                                ""
                              ),
                      }}
                    />
                    {showDetail === false &&
                      ResizedImg(
                        discussItem.html,
                        6,
                        "detail-mobile",
                        150,
                        150
                      )}
                  </div>

                  {showDetail !== false && (
                    <div className="discuss-preview-img">
                      {ResizedImg(discussItem.html, 3, "preview", 150, 150)}
                    </div>
                  )}
                </NavLink>
              </div>
            </div>
            {!hideBottom && (
              <div className="discuss-bottom-bar">
                <div style={{ display: "flex" }}>
                  <div
                    className="discuss-action"
                    onClick={() => {
                      if (showDetail !== false)
                        updateDiscussData(discussItem.id, "comment");
                    }}
                  >
                    <span style={{ marginRight: "4px" }}>
                      <CommentOutlined />
                    </span>
                    {discussItem.comments.length}
                    <span className="discuss-action-text">条评论</span>
                  </div>
                  <div
                    className={`discuss-action${
                      discussItem.liked ? "-liked" : ""
                    }`}
                    onClick={() => {
                      discussItem.liked
                        ? updateDiscussData(discussItem.id, "dislike")
                        : updateDiscussData(discussItem.id, "like");
                    }}
                  >
                    <span style={{ marginRight: "4px" }}>
                      <LikeOutlined />
                    </span>
                    {discussItem.likes !== 0 && discussItem.likes}
                    <span className="discuss-action-text">点赞</span>
                  </div>
                  <div
                    className={`discuss-action${
                      discussItem.collected ? "-collected" : ""
                    }`}
                    onClick={() => {
                      discussItem.collected
                        ? updateDiscussData(discussItem.id, "cancel_collect")
                        : updateDiscussData(discussItem.id, "add_collect");
                    }}
                  >
                    <span style={{ marginRight: "4px" }}>
                      <StarOutlined />
                    </span>
                    <span className="discuss-action-text">收藏</span>
                  </div>
                  {showDelete && (
                    <div
                      className="discuss-action"
                      onClick={() => {
                        httpclient.deleteDiscuss(discussItem.id).then((res) => {
                          if (res) {
                            notification.success({
                              message: "删除成功",
                            });
                            setTimeout(() => {
                              window.location.href = "/user/center/my-discuss";
                            }, 1000);
                          }
                        });
                      }}
                    >
                      <span style={{ marginRight: "4px" }}>
                        <DeleteOutlined />
                      </span>
                      <span className="discuss-action-text">删除</span>
                    </div>
                  )}
                  {userInfo.role === "admin" && (
                    <NavLink
                      style={{ color: "rgba(0, 0, 0, 0.85)" }}
                      className="discuss-action"
                      to={`/discuss-submit/edit/published/${discussItem.id}`}
                    >
                      <span style={{ marginRight: "4px" }}>
                        <EditOutlined />
                      </span>
                      <span className="discuss-action-text">编辑</span>
                    </NavLink>
                  )}
                </div>
                <div className="discuss-time">
                  {moment(discussItem.created_at).format("YYYY-MM-DD HH:mm")}
                </div>
              </div>
            )}
          </div>
        </div>
        {(discussItem.showComments || showDetail === false) && (
          <div className="discuss-item-comments">
            {Comments(
              discussItem,
              "discuss",
              discussItem.id,
              "",
              userInfo,
              updateUserInfo,
              showDetail !== false ? "preview" : "detail"
            )}
          </div>
        )}
      </div>
    );
  } else {
    return null;
  }
}

export default React.memo(DiscussItem, areEqual);
